import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getSellerList, getShopDataAnalyse, updateShopSaleMubiao, shopDataDownload } from '@/api/bairun/bianlidian'; //  此处请自行替换地址

import infoList from '@/mixins/infoList';
import * as DateUtil from '@/utils/date';
import * as echarts from 'echarts';
import { Common } from '@/utils/common';
import { saveAs } from 'file-saver';

var _this;

export default {
  name: 'BairunBianlidianTargetAnalyse',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return DateUtil.formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatTime: function formatTime(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return DateUtil.formatTimeToStr(date, 'MM-dd hh:mm');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getSellerShortName: function getSellerShortName(sellerId) {
      if (sellerId == 0) {
        return '总';
      }

      for (var i = 0; i < _this.sellerOptions.length; i++) {
        if (_this.sellerOptions[i].sellerId === sellerId) {
          return _this.sellerOptions[i].shortSellerName;
        }
      }

      return '';
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: '',
      type: '',
      sellerOptions: [],
      showSelSeller: false,
      searchInfo: {
        dateTime: new Date().Format('yyyy-MM-dd 00:00:00'),
        startTime: DateUtil.monthStartStr(),
        endTime: DateUtil.yesterdayEndStr(),
        sellerId: 0
      },
      checkTab: 'month',
      echartsQuShi: null,
      startTimePickerOptions: {
        disabledDate: function disabledDate(time) {
          // return ture表示日期不可选
          return !(time.getTime() >= new Date(DateUtil.monthStartStr(_this.searchInfo.startTime)) && time.getTime() <= new Date(new Date().Format('yyyy-MM-dd 23:59:59')));
        }
      },
      endTimePickerOptions: {
        disabledDate: function disabledDate(time) {
          // return ture表示日期不可选
          return !(time.getTime() >= new Date(_this.searchInfo.startTime) && time.getTime() <= new Date(new Date().Format('yyyy-MM-dd 23:59:59')));
        }
      },
      mubiaoSettingFinished: true,
      mubiaoTable: {
        table: [],
        tableOrigin: [],
        summaries: []
      },
      dateAvgTable: {
        table: [],
        summaries: []
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var sellerOptions;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getSellerList({
                  page: 1,
                  pageSize: 999999,
                  sellerSource: 1,
                  donNotShowLoading: true
                });

              case 2:
                sellerOptions = _context3.sent;
                _this3.sellerOptions = sellerOptions.data.list;

                if (_this3.sellerOptions.length === 1) {
                  _this3.sellerId = _this3.sellerOptions[0].sellerId;
                }

                _this3.onSubmit();

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onInputChange: function onInputChange() {
      this.$forceUpdate();
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.showSelSeller = false;
      this.onCheckTab();
      this.$forceUpdate();
    },
    onMonthChange: function onMonthChange() {
      // 当月
      if (new Date(this.searchInfo.dateTime).getMonth() == new Date().getMonth()) {
        this.searchInfo.startTime = DateUtil.monthStartStr(this.searchInfo.dateTime);
        this.searchInfo.endTime = DateUtil.yesterdayEndStr();
      } else {
        this.searchInfo.startTime = DateUtil.monthStartStr(this.searchInfo.dateTime);
        this.searchInfo.endTime = DateUtil.monthEndStr(this.searchInfo.dateTime);
      }

      this.onSubmit();
    },
    onCheckTab: function onCheckTab() {
      var _this4 = this;

      if (this.checkTab === 'month') {
        this.initMubiao();
      }

      if (this.checkTab === 'date') {
        this.initDateAvg();
      }

      if (this.checkTab === 'qushi') {
        this.initEchartsQuShi();
      }

      this.$nextTick(function () {
        _this4.$refs.mubiaoTable && _this4.$refs.mubiaoTable.doLayout();
        _this4.$refs.dateAvgTable && _this4.$refs.dateAvgTable.doLayout();
      });
    },
    // 月度目标
    initMubiao: function initMubiao() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var param, res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                param = {
                  'dataType': 6,
                  'sellerId': _this5.searchInfo.sellerId,
                  'period': parseInt(new Date(_this5.searchInfo.dateTime).Format('yyyyMM')),
                  'timeTag': 'month',
                  'startTime': _this5.searchInfo.startTime,
                  'endTime': _this5.searchInfo.endTime
                };
                _context4.next = 3;
                return getShopDataAnalyse(param);

              case 3:
                res = _context4.sent;

                if (res.code == 0) {
                  res.data.list.sort(function (a, b) {
                    return b.completePercent - a.completePercent;
                  });
                  _this5.mubiaoTable.table = res.data.list || [];
                  _this5.mubiaoTable.summaries = res.data.heji || [];
                  _this5.mubiaoTable.tableOrigin = JSON.parse(JSON.stringify(_this5.mubiaoTable.table));
                }

                _this5.mubiaoSettingFinished = true;

                _this5.mubiaoTable.table.forEach(function (item) {
                  if (item.targetAmount <= 0) {
                    _this5.mubiaoSettingFinished = false;
                  }
                });

                _this5.$nextTick(function () {
                  _this5.$refs.mubiaoTable && _this5.$refs.mubiaoTable.doLayout();
                });

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    getMonthSummaries: function getMonthSummaries(param) {
      return ['合计', this.mubiaoTable.summaries.totalTargetAmount, this.mubiaoTable.summaries.totalTradeAmount, (this.mubiaoTable.summaries.totalCompletePercent * 100).toFixed(2) + '%'];
    },
    // 月度目标-目标编辑
    onEditMubiao: function onEditMubiao() {
      this.type = 'editMubiao';
    },
    onCancelMubiao: function onCancelMubiao() {
      this.type = '';
      this.mubiaoTable.table = JSON.parse(JSON.stringify(this.mubiaoTable.tableOrigin));
      this.$forceUpdate();
    },
    onSaveMubiao: function onSaveMubiao() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return updateShopSaleMubiao({
                  'shopDataSaleTargetList': _this6.mubiaoTable.table.map(function (item) {
                    return {
                      'sellerId': parseInt(item.sellerId),
                      'targetAmount': parseFloat(item.targetAmount),
                      'period': parseInt(item.period)
                    };
                  })
                });

              case 2:
                res = _context5.sent;

                if (res.code == 0) {
                  _this6.$message({
                    type: 'success',
                    message: '操作成功！'
                  });

                  _this6.type = '';

                  _this6.initMubiao();
                }

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 日均目标
    initDateAvg: function initDateAvg() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var param, res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                param = {
                  'dataType': 12,
                  'sellerId': _this7.searchInfo.sellerId,
                  'period': parseInt(new Date(_this7.searchInfo.dateTime).Format('yyyyMM')),
                  'timeTag': 'month',
                  'startTime': _this7.searchInfo.startTime,
                  'endTime': _this7.searchInfo.endTime
                };
                _context6.next = 3;
                return getShopDataAnalyse(param);

              case 3:
                res = _context6.sent;

                if (res.code == 0) {
                  res.data.list.sort(function (a, b) {
                    return b.saleTargetAveragePerDay.totalAveragePerDayCompletePercent - a.saleTargetAveragePerDay.totalAveragePerDayCompletePercent;
                  });
                  _this7.dateAvgTable.table = res.data.list || [];
                  _this7.dateAvgTable.summaries = res.data.heji || [];
                }

                _this7.$nextTick(function () {
                  _this7.$refs.dateAvgTable && _this7.$refs.dateAvgTable.doLayout();
                });

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    getDateAvgSummaries: function getDateAvgSummaries(param) {
      return ['合计', this.dateAvgTable.summaries.totalAveragePerDayTargetAmount, this.dateAvgTable.summaries.totalAveragePerDayTradeAmount, (this.dateAvgTable.summaries.totalAveragePerDayCompletePercent * 100).toFixed(2) + '%', this.dateAvgTable.summaries.totalAveragePerDayDiffAmount];
    },
    // 趋势
    initEchartsQuShi: function initEchartsQuShi() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var unit, max, subtext, option, xAxis, xiaoshoue, markLine, yAxisMax, param, res;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                unit = 0;
                max = 0;
                subtext = '';
                xAxis = [];
                xiaoshoue = [];
                markLine = 0;
                yAxisMax = 0;
                param = {
                  'dataType': 13,
                  'sellerId': _this8.searchInfo.sellerId,
                  'period': new Date(_this8.searchInfo.dateTime).Format('yyyyMM'),
                  'timeTag': 'month',
                  'startTime': _this8.searchInfo.startTime,
                  'endTime': _this8.searchInfo.endTime
                };
                _context7.next = 10;
                return getShopDataAnalyse(param);

              case 10:
                res = _context7.sent;
                res.data.list && res.data.list.forEach(function (item) {
                  xAxis.push(item.dateTime);
                  xiaoshoue.push({
                    'value': item.averagePerDayTradeAmount,
                    'percent': parseFloat(item.averagePerDayCompletePercent * 100).toFixed(2),
                    'diffAmount': item.averagePerDayDiffAmount
                  });
                  yAxisMax = item.averagePerDayTargetAmount > yAxisMax ? item.averagePerDayTargetAmount : item.averagePerDayTradeAmount > yAxisMax ? item.averagePerDayTradeAmount : yAxisMax;
                  markLine = item.averagePerDayTargetAmount;
                  max = Math.max(item.averagePerDayTradeAmount, markLine);
                });
                subtext = new Date(_this8.searchInfo.dateTime).Format('MM月') + '日均目标额：' + markLine;

                if (max >= 10000) {
                  unit = 10000;
                } else if (max >= 1000) {
                  unit = 1000;
                } else {
                  unit = 0;
                }

                if (!_this8.echartsQuShi) {
                  _this8.echartsQuShi = echarts.init(document.getElementById('echartsQuShi'));
                  Common.echarts.push(_this8.echartsQuShi);
                } else {
                  _this8.echartsQuShi.resize();
                }

                option = {
                  title: {
                    subtext: subtext,
                    textStyle: {
                      fontSize: 16
                    }
                  },
                  tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                      type: 'shadow'
                    },
                    formatter: function formatter(params) {
                      debugger;
                      var s = new Date(params[0].axisValue).Format('MM月dd日') + '   ' + DateUtil.getWeekDay(params[0].axisValue);
                      s += '</br>目标额：' + markLine;
                      s += '</br>销售额：' + params[0].data.value;
                      s += '</br>完成率：' + params[0].data.percent + '%';
                      s += '</br>差额：' + params[0].data.diffAmount;
                      return s;
                    }
                  },
                  xAxis: {
                    type: 'category',
                    data: xAxis,
                    axisLabel: {
                      rotate: 60,
                      formatter: function formatter(value) {
                        return new Date(value).Format('MM/dd') + DateUtil.getWeekDay(value).replaceAll('星期', '');
                      }
                    }
                  },
                  yAxis: {
                    type: 'value',
                    axisLabel: {
                      formatter: function formatter(value) {
                        if (unit > 0) {
                          return value / unit;
                        }

                        return value;
                      }
                    }
                  },
                  grid: {
                    left: 0,
                    right: 0,
                    bottom: 0,
                    containLabel: true
                  },
                  legend: {
                    icon: 'stack',
                    data: ['销售额', '完成率'],
                    selectedMode: 'multiple'
                  },
                  series: [{
                    name: '销售额',
                    type: 'line',
                    data: xiaoshoue,
                    label: {
                      show: true,
                      position: 'top',
                      offset: [0, 40],
                      formatter: function formatter(params) {
                        return ['{value|' + parseInt(params.data.value) + '}', '{percent|' + params.data.percent + '%' + '}'].join('\n\n\n\n');
                      },
                      rich: {
                        value: {
                          color: '#409eff'
                        },
                        percent: {}
                      }
                    },
                    markLine: {
                      data: [{
                        yAxis: parseInt(markLine)
                      }],
                      label: {
                        normal: {
                          show: true,
                          position: 'middle',
                          formatter: ''
                        }
                      },
                      lineStyle: {
                        normal: {
                          type: 'solid',
                          color: 'red'
                        }
                      }
                    }
                  }]
                };
                option && _this8.echartsQuShi.setOption(option);

              case 17:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    // 下载
    onDownload: function onDownload(dataType) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var param, res;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                param = {
                  'dataType': dataType,
                  'sellerId': _this9.searchInfo.sellerId,
                  'period': parseInt(new Date(_this9.searchInfo.dateTime).Format('yyyyMM')),
                  'timeTag': 'month',
                  'startTime': _this9.searchInfo.startTime,
                  'endTime': _this9.searchInfo.endTime
                };
                _context8.next = 3;
                return shopDataDownload(param);

              case 3:
                res = _context8.sent;

                if (res.code == 0) {
                  saveAs(res.data.fileUrl);
                }

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    }
  }
};